import { chatConfigurationState } from "../models/model";
import { chatConfigActions, LoginActions } from "../interface/reducerType";
import { Types } from "../action/action";

const initialState = {
  title: "",
  description: "",
  callFlowId: "",
  callFlowName: "",
  chatIconLogo: "",
  domainArr: [],
  font: "",
  position: "flex-start",
  roundedCorners: 25,
  chatIconShape: "24",
  chatHeaderColor: "#5B55FF",
  agentMessageColor: "#F4F4F4",
  customerMessageColor: "#E2E2FA",
  actionMessageColor: "#575CFF",
  uploadDocs: false,
  createContact: false,
  chatToVoice: false,
  chatToEmail: false,
  conversationHistory: false,
  isDisplaySupportNumber: false,
  supportNumber: "",
  isWidgetUnbranding: true,
  isCallUsIcon: false,
  isSendCallBackReq: false,
  primaryForm: [],
  isSave: false,
  prechatForm: false,
  codeSnippet: "",
  hasFormError: false,
  companyName:""
};
export const chatConfiguration = (
  state: chatConfigurationState = initialState,
  action: chatConfigActions
) => {
  switch (action.type) {
    case Types.BASIC_CHAT_SETINGS:
      return {
        ...state,
        title: action.payload.title,
        description: action.payload.description,
        callFlowId: action.payload.callFlowId,
        callFlowName: action.payload.callFlowName,
        chatIconLogo: action.payload.chatIconLogo,
        domainArr: action.payload.domainArr,
      };
    case Types.PERSONALIZATION:
      return {
        ...state,
        font: action.payload.font,
        position: action.payload.position,
        roundedCorners: action.payload.roundedCorners,
        chatIconShape: action.payload.chatIconShape,
        chatHeaderColor: action.payload.chatHeaderColor,
        agentMessageColor: action.payload.agentMessageColor,
        customerMessageColor: action.payload.customerMessageColor,
        actionMessageColor: action.payload.actionMessageColor,
        uploadDocs: action.payload.uploadDocs,
        createContact: action.payload.createContact,
        chatToVoice: action.payload.chatToVoice,
        chatToEmail: action.payload.chatToEmail,
        conversationHistory: action.payload.conversationHistory,
        isDisplaySupportNumber: action.payload.isDisplaySupportNumber,
        supportNumber: action.payload.supportNumber,
        isWidgetUnbranding: action.payload.isWidgetUnbranding,
        isCallUsIcon: action.payload.isCallUsIcon,
        isSendCallBackReq: action.payload.isSendCallBackReq,
        companyName: action.payload.companyName,
      };
    case Types.PRIMARY_FORM:
      return {
        ...state,
        primaryForm: action.payload.primaryForm,
        prechatForm: action.payload.prechatForm,
      };
    case Types.IS_SAVE:
      return {
        ...state,
        isSave: action.payload.isSave,
      };
    case Types.CODE_SNIPPET:
      return {
        ...state,
        codeSnippet: action.payload.codeSnippet,
      };
    case Types.FORM_ERROR:
      return {
        ...state,
        hasFormError: action.payload.hasFormError,
      };
    default:
      return state;
  }
};
